export default [
    {key: 'index', field:'index', label: 'ลำดับ'},
    {key: 'created_at', field:'created_at', label: 'วันที่ลูกค้าส่งพัสดุ'},
    {key: 'date_time_create', field:'date_time_create', label: 'วันที่ลูกค้าสร้างรายการ'},
    {key: 'date_time_shipping', field:'date_time_shipping', label: 'วันที่ขนส่งเข้ารับ'},
    {key: 'shop_name', field:'shop_name', label: 'ชื่อร้านลูกค้า'},
    {key: 'tracking_code', field:'tracking_code', label: 'Tracking no'},
    {key: 'status', field:'status', label: 'สถานะ'}
]